export default class {
	constructor(obj) {
		this.id = obj.id
		this.beginDate = obj.beginDate
		this.endDate = obj.endDate
		this.nbMeasure = obj.nbMeasure || 0
		this.nbDebits = obj.nbDebits || 0
		this.nbHeight = obj.nbHeight || 0
		this.nbAnalysis = obj.nbAnalysis || 0
		this.typeId = obj.typeId
		this.stationId = obj.stationId
        this.samplingId = obj.samplingId
        this.samplingCode = obj.samplingPoint ? obj.samplingPoint.code || '' : ''
	}
}



// WEBPACK FOOTER //
// ./src/sites/dto/DtoKeyFiguresRow.js